import { ref, onMounted } from '@vue/composition-api';

function useSwipe(element, options) {
    var _a = options || {}, _b = _a.minSwipeDistance, minSwipeDistance = _b === void 0 ? 20 : _b, _c = _a.supportMouseEvents, supportMouseEvents = _c === void 0 ? false : _c;
    var touchStartX = ref();
    var touchStartY = ref();
    var handlers = {
        up: null,
        down: null,
        left: null,
        right: null,
    };
    onMounted(function () {
        if (!element.value) {
            return;
        }
        element.value.addEventListener('touchstart', onTouchStart, { passive: true });
        element.value.addEventListener('touchend', onTouchEnd, { passive: true });
        if (supportMouseEvents) {
            element.value.addEventListener('mousedown', onClickStart, { passive: true });
            element.value.addEventListener('mouseup', onClickEnd, { passive: true });
        }
    });
    function onTouchStart(event) {
        if (!event.touches.length) {
            return;
        }
        var _a = event.touches[0], screenX = _a.screenX, screenY = _a.screenY;
        onMoveStart(screenX, screenY);
    }
    function onClickStart(event) {
        onMoveStart(event.screenX, event.screenY);
    }
    function onMoveStart(x, y) {
        touchStartX.value = x;
        touchStartY.value = y;
    }
    function onTouchEnd(event) {
        if (!event.changedTouches.length) {
            return;
        }
        var _a = event.changedTouches[0], screenX = _a.screenX, screenY = _a.screenY;
        onMoveEnd(screenX, screenY);
    }
    function onClickEnd(event) {
        onMoveEnd(event.screenX, event.screenY);
    }
    function onMoveEnd(x, y) {
        var _a, _b, _c, _d;
        var diffX = x - touchStartX.value;
        var diffY = y - touchStartY.value;
        if (Math.abs(diffX) < minSwipeDistance && Math.abs(diffY) < minSwipeDistance) {
            return;
        }
        if (Math.abs(diffX) >= Math.abs(diffY)) {
            if (diffX > 0) {
                (_a = handlers.left) === null || _a === void 0 ? void 0 : _a.call(handlers);
            }
            else {
                (_b = handlers.right) === null || _b === void 0 ? void 0 : _b.call(handlers);
            }
        }
        else {
            if (diffY > 0) {
                (_c = handlers.up) === null || _c === void 0 ? void 0 : _c.call(handlers);
            }
            else {
                (_d = handlers.down) === null || _d === void 0 ? void 0 : _d.call(handlers);
            }
        }
    }
    return {
        onRightSwipe: function (handler) {
            handlers.right = handler;
        },
        onLeftSwipe: function (handler) {
            handlers.left = handler;
        },
        onUpSwipe: function (handler) {
            handlers.up = handler;
        },
        onDownSwipe: function (handler) {
            handlers.down = handler;
        },
    };
}

export { useSwipe };
